import { Box, CircularProgress, Typography } from "@mui/material";

export const FullScreenLoader = ({ text }: { text?: string }) => (
  <Box
    data-testid="full-screen-loader"
    sx={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      alignItems: "center",
    }}
  >
    <CircularProgress />
    {text && <Typography sx={{ mt: 2 }}>{text}</Typography>}
  </Box>
);
